import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative z-50" }
const _hoisted_2 = { class: "text-secondary text-13 h-full border-b-4 border-transparent hidden md:block" }
const _hoisted_3 = { class: "md:hidden text-secondary-dark text-20 mr-3" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white absolute right-0 top-18 md:top-16 md:mt-1 w-44 rounded-lg\n        overflow-hidden shadow-dropdown z-50 border border-secondary-light"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", { class: "border-menu-dark" }, null, -1)
const _hoisted_6 = {
  class: "px-5 py-2.5 hover:bg-list-hover block",
  href: "https://imagesuggest.com/pricing/#FAQ"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_PlanLabel = _resolveComponent("PlanLabel")
  const _component_router_link = _resolveComponent("router-link")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      class: [
        'cursor-pointer border-b-4 border-transparent pb-4 pt-6',
        _ctx.dropdownVisible && 'border-tab-main'
      ],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.userName || _ctx.$t('header.profile-dropdown.label')) + " ", 1),
        _withDirectives(_createVNode(_component_font_awesome_icon, {
          class: "ml-3",
          icon: ['fas', 'chevron-down']
        }, null, 512), [
          [_vShow, !_ctx.dropdownVisible]
        ]),
        _withDirectives(_createVNode(_component_font_awesome_icon, {
          class: "ml-3",
          icon: ['fas', 'chevron-up']
        }, null, 512), [
          [_vShow, _ctx.dropdownVisible]
        ])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          class: "ml-3",
          icon: ['fas', 'user-circle']
        })
      ])
    ], 2), [
      [_directive_click_outside, _ctx.hideDropdown]
    ]),
    (_ctx.dropdownVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_PlanLabel, { class: "p-2.5" }),
          _hoisted_5,
          _createVNode(_component_router_link, {
            class: "px-5 py-2.5 hover:bg-list-hover block",
            to: { name: 'my-account' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('header.profile-dropdown.links.my-account')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "px-5 py-2.5 hover:bg-list-hover block",
            to: { name: 'membership' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('header.profile-dropdown.links.membership')), 1)
            ]),
            _: 1
          }),
          _createVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('header.profile-dropdown.links.faq-and-help')), 1),
          _createVNode(_component_BaseButton, {
            class: "px-5 py-2.5 hover:bg-list-hover block cursor-pointer w-full text-black text-left font-normal",
            link: "",
            onClick: _ctx.onLogOut
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('header.profile-dropdown.links.sign-out')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}